{
  "courses": {
    "title": "Courses & Training",
    "createButton": "New Course",
    "createStudentButton": "New Student",
    "createTitle": "Create Course",
    "editTitle": "Edit Course",
    "backToList": "Back to courses",
    "searchPlaceholder": "Search by title or location...",
    "allStatuses": "All statuses",
    "allLevels": "All levels",
    "noData": "No courses found",
    "noTeacher": "No teacher assigned",
    "nextSession": "Next session:",
    "columns": {
      "title": "Title",
      "level": "Level",
      "duration": "Duration",
      "price": "Price",
      "status": "Status",
      "nextSession": "Next session",
      "fill": "Fill",
      "teachers": "Teachers"
    },
    "level": {
      "Basic": "Basic",
      "Intermediate": "Intermediate",
      "Expert": "Expert",
      "ExpertFinishes": "Expert — Finishes"
    },
    "status": {
      "Draft": "Draft",
      "Published": "Published",
      "Archived": "Archived"
    },
    "sessionStatus": {
      "Scheduled": "Scheduled",
      "Open": "Open",
      "Full": "Full",
      "Cancelled": "Cancelled",
      "Completed": "Completed"
    },
    "form": {
      "title": "Title",
      "titleRequired": "Title is required",
      "description": "Description",
      "level": "Level",
      "status": "Status",
      "durationMinutes": "Duration (minutes)",
      "location": "Location",
      "language": "Language",
      "maxStudents": "Max students",
      "price": "Price (EUR)"
    },
    "archive": {
      "title": "Archive course",
      "confirm": "Are you sure you want to archive \"{{title}}\"?",
      "action": "Archive"
    },
    "sessions": {
      "title": "Sessions",
      "empty": "No sessions yet",
      "noComing": "No upcoming sessions",
      "showPast": "Show past ({{count}})"
    },
    "session": {
      "createButton": "Add Session",
      "createTitle": "Add Session",
      "editTitle": "Edit Session",
      "date": "Date",
      "startTime": "Start time",
      "endTime": "End time",
      "location": "Location",
      "country": "Country",
      "availableSeats": "Available seats",
      "status": "Status",
      "seats": "seats",
      "until": "until",
      "enrollments": "Enrollments",
      "students": "Students",
      "noStudents": "No students enrolled",
      "addStudent": "Add a student",
      "edit": "Edit session",
      "deleteTitle": "Delete session",
      "deleteConfirm": "Are you sure you want to delete this session? All enrollments will be removed.",
      "complete": "Mark complete",
      "reopen": "Reopen"
    },
    "enroll": {
      "title": "Enroll a student",
      "button": "Enroll",
      "action": "Enroll",
      "search": "Search students",
      "searchPlaceholder": "Type to search...",
      "student": "Student",
      "studentPlaceholder": "Select a student...",
      "noResults": "No students found",
      "noEnrollments": "No enrollments yet",
      "remove": "Remove enrollment",
      "removeTitle": "Remove enrollment",
      "removeConfirm": "Remove {{name}} from this session?",
      "columns": {
        "name": "Name",
        "email": "Email",
        "enrolledAt": "Enrolled on"
      }
    },
    "teachers": {
      "title": "Teachers",
      "add": "Add a teacher",
      "empty": "No teacher assigned",
      "assign": "Assign",
      "removeTitle": "Remove teacher",
      "removeConfirm": "Remove {{name}} from this course?",
      "select": "Select a teacher..."
    },
    "enrollmentStatus": {
      "Registered": "Registered",
      "Attended": "Attended",
      "Completed": "Completed",
      "Cancelled": "Cancelled"
    },
    "attendance": {
      "edit": "Edit attendance",
      "present": "Present",
      "absent": "Absent",
      "comment": "Comment",
      "commentTitle": "Add a comment",
      "commentPlaceholder": "Comment (optional)..."
    },
    "create": {
      "successTitle": "Course created",
      "successMessage": "The course has been created successfully.",
      "errorTitle": "Error",
      "errorMessage": "Unable to create the course."
    }
  }
}